/**
 * Subscription LP Script - 花の店 あい花
 * 
 * Dependencies: None (Vanilla ES6+)
 * Performance & Accessibility focused
 */

document.addEventListener('DOMContentLoaded', () => {
  /**
   * 1. IntersectionObserverによるスクロールフェードイン制御
   */
  const initFadeInObserver = () => {
    const fadeElements = document.querySelectorAll('.sub-lp-js-fade');

    if (!fadeElements.length) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.15
    };

    const fadeObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // 一度表示された要素は監視対象から外して負荷を軽減
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    fadeElements.forEach((element) => {
      fadeObserver.observe(element);
    });
  };

  /**
   * 2. FAQ アコーディオン制御（アクセシビリティ & トランジション強化）
   */
  const initFaqAccordion = () => {
    const faqItems = document.querySelectorAll('.sub-lp__faq-item');

    if (!faqItems.length) return;

    faqItems.forEach((item) => {
      const summary = item.querySelector('.sub-lp__faq-question');
      const answer = item.querySelector('.sub-lp__faq-answer');

      if (!summary || !answer) return;

      summary.addEventListener('click', (event) => {
        // 標準のtoggle動作を一時停止してアニメーションを制御
        event.preventDefault();

        const isOpen = item.hasAttribute('open');

        if (isOpen) {
          // 閉じる処理
          answer.style.height = `${answer.offsetHeight}px`;
          
          // リフローを発生させてから0pxに変更
          requestAnimationFrame(() => {
            answer.style.transition = 'height 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease';
            answer.style.height = '0px';
            answer.style.opacity = '0';
          });

          const onTransitionEnd = (e) => {
            if (e.propertyName === 'height') {
              item.removeAttribute('open');
              answer.style.removeProperty('height');
              answer.style.removeProperty('opacity');
              answer.style.removeProperty('transition');
              answer.removeEventListener('transitionend', onTransitionEnd);
            }
          };

          answer.addEventListener('transitionend', onTransitionEnd);
        } else {
          // 開く処理
          item.setAttribute('open', '');
          const targetHeight = answer.scrollHeight;

          answer.style.height = '0px';
          answer.style.opacity = '0';

          requestAnimationFrame(() => {
            answer.style.transition = 'height 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease';
            answer.style.height = `${targetHeight}px`;
            answer.style.opacity = '1';
          });

          const onTransitionEnd = (e) => {
            if (e.propertyName === 'height') {
              answer.style.removeProperty('height');
              answer.style.removeProperty('opacity');
              answer.style.removeProperty('transition');
              answer.removeEventListener('transitionend', onTransitionEnd);
            }
          };

          answer.addEventListener('transitionend', onTransitionEnd);
        }
      });
    });
  };

  /**
   * 3. ページ内アンカー（#coursesなど）のスムーススクロール制御
   */
  const initSmoothScroll = () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const targetId = link.getAttribute('href');
        if (targetId === '#' || !targetId) return;

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          
          // ヘッダー固定値などのオフセット考慮
          const headerOffset = 60;
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  };

  /**
   * 4. 画像ズームのHover最適化 (CLS・パフォーマンス配慮)
   */
  const initImageZoomEffects = () => {
    const zoomContainers = document.querySelectorAll('.sub-lp-js-zoom');

    zoomContainers.forEach((container) => {
      const img = container.querySelector('img');
      if (!img) return;

      container.addEventListener('mouseenter', () => {
        img.style.willChange = 'transform';
      });

      container.addEventListener('mouseleave', () => {
        img.style.willChange = 'auto';
      });
    });
  };

  // すべての初期化関数を実行
  initFadeInObserver();
  initFaqAccordion();
  initSmoothScroll();
  initImageZoomEffects();
});